theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');

    if(headerStickyTarget){
      let headerHeight = headerStickyWrapper.clientHeight;
      let lastScrollY = window.scrollY;
      let ticking = false;

      function update(){
        let currentScrollY = window.scrollY;

        if(currentScrollY > headerHeight){
          headerStickyTarget.classList.add('sticky');

          if(currentScrollY > lastScrollY){
            // rolando para baixo -> esconde
            headerStickyTarget.classList.add('header--hide');
          } else {
            // rolando para cima -> mostra
            headerStickyTarget.classList.remove('header--hide');
          }
        } else {
          headerStickyTarget.classList.remove('sticky');
          headerStickyTarget.classList.remove('header--hide');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      }

      window.addEventListener('scroll', function(){
        if(!ticking){
          window.requestAnimationFrame(update);
          ticking = true;
        }
      })
    }


  }
  return ScrollSticky;
})();
